import { render, staticRenderFns } from "./addGroupActivitySubmit.vue?vue&type=template&id=be61b688&scoped=true&"
import script from "./addGroupActivitySubmit.vue?vue&type=script&lang=js&"
export * from "./addGroupActivitySubmit.vue?vue&type=script&lang=js&"
import style0 from "./addGroupActivitySubmit.vue?vue&type=style&index=0&id=be61b688&scoped=true&lang=css&"
import style1 from "./addGroupActivitySubmit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be61b688",
  null
  
)

export default component.exports